<template>
  <BuilderWrapper
    title="Search"
    :helpful-tip="`The search function allows users to filter the results based on a specific keyword.`"
    :show-premium-feature="!featureEnabled"
    :expand-disabled="!featureEnabled"
  >
    <LabelledInput v-if="featureEnabled">
      <b-checkbox v-model="enableSearchForProjects">
        Enable search for projects by keyword
      </b-checkbox>
    </LabelledInput>

    <template v-if="featureEnabled && enableSearch && !exclude.includes('settings')">
      <LabelledInput
        v-if="enableSearchForProjects && !exclude.includes('fieldResult')"
        label="Search Field Result"
        :helpful-tip="`Choose the field(s) that will display in the search results box when searching by project. By default ${leafLevelName} is displayed.`"
      >
        <SearchResultFields />
      </LabelledInput>
    </template>
  </BuilderWrapper>
</template>

<script lang="ts">

import { PropType } from 'vue'
import Component from 'vue-class-component'

import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import SearchResultFields from '@/components/builder/SearchSettings/SearchResultFields.vue'
import FeatureSetMixin from '@/mixins/FeatureSetMixin'
import { FeatureKeys } from '@/types'
import { SEARCH_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  LabelledInput,
  SearchResultFields,
}

const props = {
  exclude: {
    type: Array as PropType<string[]>,
    default: () => ['h5'],
  },
}

// eslint-disable-next-line no-use-before-define
@Component<SearchSettings>({
  components,
  watch: {
    enableSearch () {
      this.$typedStore.public.search.resetState()
    },
    enableSearchForProjects (newValue) {
      this.enableSearch = newValue || this.enableSearchByLocation
    },
  },
})
export default class SearchSettings extends FeatureSetMixin.extend({ props }) {
  featureKey = FeatureKeys.SEARCH
  featureEnabled!: boolean

  get enableSearch () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].enabled
  }

  set enableSearch (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'enabled'],
      value,
    })
  }

  get enableSearchForProjects () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].enableSearchForProjects
  }

  set enableSearchForProjects (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'enableSearchForProjects'],
      value,
    })
  }

  get enableSearchByLocation () {
    return this.$typedStore.primary.app.config[SEARCH_CONFIG_KEY].enableSearchByLocation
  }

  set enableSearchByLocation (value) {
    this.$typedStore.primary.app.updateConfig({
      configPath: [SEARCH_CONFIG_KEY, 'enableSearchByLocation'],
      value,
    })
  }

  get leafLevelName () {
    return this.$typedStore.primary.app.levels.leafLevelField?.name || ''
  }
}

</script>
